var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStateWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 376,
    height: 375,
    viewBox: "0 0 376 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.625,
    cy: 187.578,
    fill: "#E85434",
    opacity: 0.03,
    rx: 187.406,
    ry: 187.359
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73 73)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.943,
    cy: 114.914,
    fill: "#E85434",
    rx: 114.943,
    ry: 114.914
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.991 67.54v47.921c0 6.59-5.396 11.98-11.991 11.98s-11.992-5.391-11.992-11.98V67.54c0-6.59 5.397-11.98 11.992-11.98 6.595 0 11.991 5.39 11.991 11.98zM115 139.422c-9.953 0-17.987 8.026-17.987 17.97 0 9.944 8.034 17.972 17.987 17.972 9.953 0 17.987-8.027 17.987-17.971s-8.034-17.971-17.987-17.971z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateWarning);
export default __webpack_public_path__ + "static/media/state-warning.a51156dabf845c84dce7b1ae99f02d76.svg";
export { ForwardRef as ReactComponent };